import { queryOptions } from '@tanstack/react-query';

import { type CalendarPageData, getCalendarPageData } from './get-calendar-page-data.ts';

const CALENDAR_PAGE_DATA_STALE_TIME_MS = 60_000;

export interface CalendarPageDataQueryInput {
	readonly epoch?: string | null;
}

export function getCalendarPageDataQueryOptions({ epoch = null }: CalendarPageDataQueryInput = {}) {
	return queryOptions<CalendarPageData>({
		queryFn: () =>
			getCalendarPageData({
				data: {
					epoch,
				},
			}),
		queryKey: ['calendar-page-data', epoch],
		staleTime: CALENDAR_PAGE_DATA_STALE_TIME_MS,
	});
}
